export default __webpack_public_path__ + "static/media/emptycart.fa871efc.png";